import {TableTemplate} from '@/modules/Attachments/types'

export const fieldToLabel = (field: string) => {
  const result = field.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
}

export const queryAttachmentsList = (leadID: string | (string | null)[], count = 50, from = 0, to = 50) => {
  return {
    query: {
      operands: [
        [
          {
            name: "Model",
            condition: "INLIST",
            value: ["Contacts"]
          },
          {
            name: "RowID",
            condition: "eq",
            value: [leadID]
          }
        ]
      ]
    },
    count,
    from,
    to
  }
}

export const AttachmentTableColumns = [
  'Name',
  // 'attachedBy',
  // 'Created',
  'Size',

  // 'Id',
  'Created',
  'Completed',
  // 'Progress',
  // 'Type',
  // 'Info',
  'Status'
]

export const AttachmentColumns: Array<TableTemplate> = AttachmentTableColumns.map(
  el => ({field: el, header: fieldToLabel(el)})
)

export const ContentTableColumns = [
  'Ticker',
  'MarketValue',
  'ExpenceRatio',
  'FullTextInOriginalFile',
  'Name',
]

export const ContentColumns: Array<TableTemplate> = ContentTableColumns.map(
  el => {
   const column = {field: el, header: fieldToLabel(el)}

   if (el == 'ExpenceRatio'){
     column.header = fieldToLabel('ExpenseRatio');
   }

   return column;
  }
)
